import { useState } from "react";

const EMPTY_FORM = {
  name: "",
  email: "",
  subject: "",
  message: "",
};

function validateForm(values) {
  const errors = {};
  if (!values.name.trim()) errors.name = "Name is required.";
  if (!values.email.trim()) {
    errors.email = "Email is required.";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
    errors.email = "Please enter a valid email address.";
  }
  if (!values.subject.trim()) errors.subject = "Subject is required.";
  if (!values.message.trim()) errors.message = "Message is required.";
  return errors;
}

export function ContactForm({ toEmail }) {
  const [values, setValues] = useState(EMPTY_FORM);
  const [errors, setErrors] = useState({});

  const onChange = (event) => {
    const { name, value } = event.target;
    setValues((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const onSubmit = (event) => {
    event.preventDefault();
    const nextErrors = validateForm(values);
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;

    const subject = encodeURIComponent(values.subject.trim());
    const body = encodeURIComponent(
      `Name: ${values.name.trim()}\nEmail: ${values.email.trim()}\n\n${values.message.trim()}`
    );
    window.location.href = `mailto:${toEmail}?subject=${subject}&body=${body}`;
    setValues(EMPTY_FORM);
  };

  const inputClass =
    "w-full rounded-xl border border-white/30 bg-white/10 px-4 py-3 text-sm text-white placeholder:text-maroon-100/70 outline-none transition focus:border-white focus:ring-2 focus:ring-white/40";
  const errorClass = "mt-1 text-left text-xs text-maroon-100";

  return (
    <form onSubmit={onSubmit} noValidate className="mt-8 grid gap-4 text-left">
      <div className="grid gap-4 sm:grid-cols-2">
        <label className="block">
          <span className="mb-1 block text-sm font-medium text-maroon-50">Full name</span>
          <input
            type="text"
            name="name"
            value={values.name}
            onChange={onChange}
            className={inputClass}
            placeholder="Your name"
            autoComplete="name"
          />
          {errors.name ? <p className={errorClass}>{errors.name}</p> : null}
        </label>

        <label className="block">
          <span className="mb-1 block text-sm font-medium text-maroon-50">Email address</span>
          <input
            type="email"
            name="email"
            value={values.email}
            onChange={onChange}
            className={inputClass}
            placeholder="you@example.com"
            autoComplete="email"
          />
          {errors.email ? <p className={errorClass}>{errors.email}</p> : null}
        </label>
      </div>

      <label className="block">
        <span className="mb-1 block text-sm font-medium text-maroon-50">Subject</span>
        <input
          type="text"
          name="subject"
          value={values.subject}
          onChange={onChange}
          className={inputClass}
          placeholder="How can we help?"
        />
        {errors.subject ? <p className={errorClass}>{errors.subject}</p> : null}
      </label>

      <label className="block">
        <span className="mb-1 block text-sm font-medium text-maroon-50">Message</span>
        <textarea
          name="message"
          value={values.message}
          onChange={onChange}
          className={inputClass}
          placeholder="Write your message"
          rows={5}
        />
        {errors.message ? <p className={errorClass}>{errors.message}</p> : null}
      </label>

      <button
        type="submit"
        className="inline-flex items-center justify-center rounded-xl bg-white px-5 py-3 text-sm font-semibold text-maroon-900 shadow-md transition hover:bg-maroon-50"
      >
        Send message
      </button>
    </form>
  );
}
